import CodeBlock from './CodeBlock';
import Heading from './Heading';
import Link from './Link';
import Paragraph from './Paragraph';
import Strong from './Strong';
import CustomerQuote from './CustomerQuote';
import Blockquote from './Blockquote';
import UnorderedList from './UnorderedList';
import OrderedList from './OrderedList';
import ListItem from './ListItem';
import HorizontalRule from './HorizontalRule';
import Table from './Table';
import THead from './THead';
import TableHeader from './TableHeader';
import TableD from './TableD';
import ComparisonTableD from './ComparisonTableD';

const renderers = {
  CodeBlock,
  Heading,
  Link,
  Paragraph,
  Strong,
  CustomerQuote,
  Blockquote,
  UnorderedList,
  OrderedList,
  ListItem,
  HorizontalRule,
  Table,
  THead,
  TableHeader,
  TableD,
  ComparisonTableD,
};

export default renderers;
